module.exports = __webpack_public_path__ + "img/dash-square-fill.acef9ca4.svg";